/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/*
* Branni Pets - Size Calculator v6
*/

(function () {
  const CALCULATOR_VERSION = 'v6';

  const BREED_NAMES = {
  bichon_maltes: {
    es: 'Bichón Maltés',
    en: 'Maltese',
    fr: 'Bichon maltais',
    de: 'Malteser',
    it: 'Bichon maltese'
  },

  caniche_toy: {
    es: 'Caniche Toy',
    en: 'Toy Poodle',
    fr: 'Caniche Toy',
    de: 'Toy-Pudel',
    it: 'Barboncino Toy'
  },

  pomerania: {
    es: 'Pomerania',
    en: 'Pomeranian',
    fr: 'Spitz nain',
    de: 'Zwergspitz',
    it: 'Volpino di Pomerania'
  },

  chihuahua: {
    es: 'Chihuahua',
    en: 'Chihuahua',
    fr: 'Chihuahua',
    de: 'Chihuahua',
    it: 'Chihuahua'
  },

  yorkshire_terrier: {
    es: 'Yorkshire Terrier',
    en: 'Yorkshire Terrier',
    fr: 'Yorkshire Terrier',
    de: 'Yorkshire Terrier',
    it: 'Yorkshire Terrier'
  },

  shih_tzu: {
    es: 'Shih Tzu',
    en: 'Shih Tzu',
    fr: 'Shih Tzu',
    de: 'Shih Tzu',
    it: 'Shih Tzu'
  },

  teckel_miniatura: {
    es: 'Teckel Miniatura',
    en: 'Miniature Dachshund',
    fr: 'Teckel nain',
    de: 'Zwergdackel',
    it: 'Bassotto nano'
  },

  teckel: {
    es: 'Teckel',
    en: 'Dachshund',
    fr: 'Teckel',
    de: 'Dackel',
    it: 'Bassotto'
  },

  bulldog_frances: {
    es: 'Bulldog Francés',
    en: 'French Bulldog',
    fr: 'Bouledogue Français',
    de: 'Französische Bulldogge',
    it: 'Bulldog francese'
  },

  whippet: {
    es: 'Whippet',
    en: 'Whippet',
    fr: 'Whippet',
    de: 'Whippet',
    it: 'Whippet'
  },

  jack_russell_terrier: {
    es: 'Jack Russell Terrier',
    en: 'Jack Russell Terrier',
    fr: 'Jack Russell Terrier',
    de: 'Jack Russell Terrier',
    it: 'Jack Russell Terrier'
  },

  cavalier_king_charles_spaniel: {
    es: 'Cavalier King Charles Spaniel',
    en: 'Cavalier King Charles Spaniel',
    fr: 'Cavalier King Charles',
    de: 'Cavalier King Charles Spaniel',
    it: 'Cavalier King Charles Spaniel'
  },

  beagle: {
    es: 'Beagle',
    en: 'Beagle',
    fr: 'Beagle',
    de: 'Beagle',
    it: 'Beagle'
  },

  galgo_italiano: {
    es: 'Galgo Italiano',
    en: 'Italian Greyhound',
    fr: 'Petit Lévrier Italien',
    de: 'Italienisches Windspiel',
    it: 'Levriero Italiano'
  },

  galgo_espanol: {
    es: 'Galgo Español',
    en: 'Spanish Greyhound',
    fr: 'Galgo Espagnol',
    de: 'Spanischer Galgo',
    it: 'Galgo Spagnolo'
  },

  cocker_spaniel_ingles: {
    es: 'Cocker Spaniel Inglés',
    en: 'English Cocker Spaniel',
    fr: 'Cocker Spaniel Anglais',
    de: 'Englischer Cocker Spaniel',
    it: 'Cocker Spaniel Inglese'
  },

  border_collie: {
    es: 'Border Collie',
    en: 'Border Collie',
    fr: 'Border Collie',
    de: 'Border Collie',
    it: 'Border Collie'
  },

  schnauzer_miniatura: {
    es: 'Schnauzer Miniatura',
    en: 'Miniature Schnauzer',
    fr: 'Schnauzer Nain',
    de: 'Zwergschnauzer',
    it: 'Schnauzer Nano'
  },

  bichon_frise: {
    es: 'Bichón Frisé',
    en: 'Bichon Frise',
    fr: 'Bichon Frisé',
    de: 'Bichon Frisé',
    it: 'Bichon Frisé'
  },

  labrador_retriever: {
    es: 'Labrador Retriever',
    en: 'Labrador Retriever',
    fr: 'Labrador Retriever',
    de: 'Labrador Retriever',
    it: 'Labrador Retriever'
  },

  golden_retriever: {
    es: 'Golden Retriever',
    en: 'Golden Retriever',
    fr: 'Golden Retriever',
    de: 'Golden Retriever',
    it: 'Golden Retriever'
  },

  pastor_aleman: {
    es: 'Pastor Alemán',
    en: 'German Shepherd',
    fr: 'Berger Allemand',
    de: 'Deutscher Schäferhund',
    it: 'Pastore Tedesco'
  },

  maltipoo: {
    es: 'Maltipoo',
    en: 'Maltipoo',
    fr: 'Maltipoo',
    de: 'Maltipoo',
    it: 'Maltipoo'
  },

  cavapoo: {
    es: 'Cavapoo',
    en: 'Cavapoo',
    fr: 'Cavapoo',
    de: 'Cavapoo',
    it: 'Cavapoo'
  },

  greyhound: {
    es: 'Greyhound',
    en: 'Greyhound',
    fr: 'Greyhound',
    de: 'Greyhound',
    it: 'Greyhound'
  },

  otra_raza: {
    es: 'Otra raza',
    en: 'Other breed',
    fr: 'Autre race',
    de: 'Andere Rasse',
    it: 'Altra razza'
  },

    boston_terrier: {
    es: 'Boston Terrier',
    en: 'Boston Terrier',
    fr: 'Boston Terrier',
    de: 'Boston Terrier',
    it: 'Boston Terrier'
  },

  australian_shepherd: {
    es: 'Pastor Australiano',
    en: 'Australian Shepherd',
    fr: 'Berger Australien',
    de: 'Australian Shepherd',
    it: 'Pastore Australiano'
  },

  shiba_inu: {
    es: 'Shiba Inu',
    en: 'Shiba Inu',
    fr: 'Shiba Inu',
    de: 'Shiba Inu',
    it: 'Shiba Inu'
  },

  bichon_habanero: {
    es: 'Bichón Habanero',
    en: 'Havanese',
    fr: 'Bichon Havanais',
    de: 'Havaneser',
    it: 'Bichon Havanais'
  },

  bulldog_ingles: {
    es: 'Bulldog Inglés',
    en: 'English Bulldog',
    fr: 'Bouledogue Anglais',
    de: 'Englische Bulldogge',
    it: 'Bulldog Inglese'
  },

  boxer: {
    es: 'Boxer',
    en: 'Boxer',
    fr: 'Boxer',
    de: 'Boxer',
    it: 'Boxer'
  },

  staffordshire_bull_terrier: {
    es: 'Staffordshire Bull Terrier',
    en: 'Staffordshire Bull Terrier',
    fr: 'Staffordshire Bull Terrier',
    de: 'Staffordshire Bull Terrier',
    it: 'Staffordshire Bull Terrier'
  },

  dalmata: {
    es: 'Dálmata',
    en: 'Dalmatian',
    fr: 'Dalmatien',
    de: 'Dalmatiner',
    it: 'Dalmata'
  },

  cocker_spaniel_americano: {
    es: 'Cocker Spaniel Americano',
    en: 'American Cocker Spaniel',
    fr: 'Cocker Américain',
    de: 'Amerikanischer Cocker Spaniel',
    it: 'Cocker Spaniel Americano'
  },

  poochon: {
    es: 'Poochon',
    en: 'Poochon',
    fr: 'Poochon',
    de: 'Poochon',
    it: 'Poochon'
  },

  podenco_ibicenco: {
    es: 'Podenco Ibicenco',
    en: 'Ibizan Hound',
    fr: 'Podenco d’Ibiza',
    de: 'Ibiza-Podenco',
    it: 'Podenco Ibicenco'
  },

  dobermann: {
    es: 'Dobermann',
    en: 'Doberman',
    fr: 'Dobermann',
    de: 'Dobermann',
    it: 'Dobermann'
  },

  springer_spaniel_ingles: {
    es: 'Springer Spaniel Inglés',
    en: 'English Springer Spaniel',
    fr: 'Springer Spaniel Anglais',
    de: 'English Springer Spaniel',
    it: 'Springer Spaniel Inglese'
  },

  pekines: {
    es: 'Pekinés',
    en: 'Pekingese',
    fr: 'Pékinois',
    de: 'Pekinese',
    it: 'Pechinese'
  },

  podenco_andaluz: {
    es: 'Podenco Andaluz',
    en: 'Andalusian Hound',
    fr: 'Podenco Andalou',
    de: 'Andalusischer Podenco',
    it: 'Podenco Andaluso'
  },

  rottweiler: {
    es: 'Rottweiler',
    en: 'Rottweiler',
    fr: 'Rottweiler',
    de: 'Rottweiler',
    it: 'Rottweiler'
  },

  basenji: {
    es: 'Basenji',
    en: 'Basenji',
    fr: 'Basenji',
    de: 'Basenji',
    it: 'Basenji'
  },

  papillon: {
    es: 'Papillón',
    en: 'Papillon',
    fr: 'Papillon',
    de: 'Papillon',
    it: 'Papillon'
  },

  saluki: {
    es: 'Saluki',
    en: 'Saluki',
    fr: 'Saluki',
    de: 'Saluki',
    it: 'Saluki'
  },

  weimaraner: {
    es: 'Weimaraner',
    en: 'Weimaraner',
    fr: 'Braque de Weimar',
    de: 'Weimaraner',
    it: 'Weimaraner'
  },

  breton: {
    es: 'Bretón',
    en: 'Brittany Spaniel',
    fr: 'Épagneul Breton',
    de: 'Bretone',
    it: 'Epagneul Breton'
  },

  pinscher_miniatura: {
    es: 'Pinscher Miniatura',
    en: 'Miniature Pinscher',
    fr: 'Pinscher Nain',
    de: 'Zwergpinscher',
    it: 'Pinscher Nano'
  },

  borzoi: {
    es: 'Borzoi',
    en: 'Borzoi',
    fr: 'Barzoï',
    de: 'Borzoi',
    it: 'Borzoi'
  },

  pastor_belga_malinois: {
    es: 'Pastor Belga Malinois',
    en: 'Belgian Malinois',
    fr: 'Berger Belge Malinois',
    de: 'Belgischer Schäferhund Malinois',
    it: 'Pastore Belga Malinois'
  },

  podenco_mediano: {
    es: 'Podenco Mediano',
    en: 'Medium Podenco',
    fr: 'Podenco Moyen',
    de: 'Mittelgroßer Podenco',
    it: 'Podenco Medio'
  },

  russian_toy: {
    es: 'Russian Toy',
    en: 'Russian Toy',
    fr: 'Russian Toy',
    de: 'Russkiy Toy',
    it: 'Russian Toy'
  },

    setter_ingles: {
    es: 'Setter Inglés',
    en: 'English Setter',
    fr: 'Setter Anglais',
    de: 'English Setter',
    it: 'Setter Inglese'
  },

  coton_de_tulear: {
    es: 'Coton de Tuléar',
    en: 'Coton de Tulear',
    fr: 'Coton de Tuléar',
    de: 'Coton de Tuléar',
    it: 'Coton de Tuléar'
  },

  norfolk_terrier: {
    es: 'Norfolk Terrier',
    en: 'Norfolk Terrier',
    fr: 'Norfolk Terrier',
    de: 'Norfolk Terrier',
    it: 'Norfolk Terrier'
  },

  setter_irlandes: {
    es: 'Setter Irlandés',
    en: 'Irish Setter',
    fr: 'Setter Irlandais',
    de: 'Irischer Setter',
    it: 'Setter Irlandese'
  },

  norwich_terrier: {
    es: 'Norwich Terrier',
    en: 'Norwich Terrier',
    fr: 'Norwich Terrier',
    de: 'Norwich Terrier',
    it: 'Norwich Terrier'
  },

  vizsla: {
    es: 'Vizsla',
    en: 'Vizsla',
    fr: 'Vizsla',
    de: 'Vizsla',
    it: 'Vizsla'
  },

  gran_danes: {
    es: 'Gran Danés',
    en: 'Great Dane',
    fr: 'Dogue Allemand',
    de: 'Deutsche Dogge',
    it: 'Alano Tedesco'
  },

  scottish_terrier: {
    es: 'Scottish Terrier',
    en: 'Scottish Terrier',
    fr: 'Scottish Terrier',
    de: 'Scottish Terrier',
    it: 'Scottish Terrier'
  },

  braco_aleman: {
    es: 'Braco Alemán',
    en: 'German Shorthaired Pointer',
    fr: 'Braque Allemand',
    de: 'Deutsch Kurzhaar',
    it: 'Bracco Tedesco'
  },

  terranova: {
    es: 'Terranova',
    en: 'Newfoundland',
    fr: 'Terre-Neuve',
    de: 'Neufundländer',
    it: 'Terranova'
  },

  welsh_terrier: {
    es: 'Welsh Terrier',
    en: 'Welsh Terrier',
    fr: 'Welsh Terrier',
    de: 'Welsh Terrier',
    it: 'Welsh Terrier'
  },

  rhodesian_ridgeback: {
    es: 'Rhodesian Ridgeback',
    en: 'Rhodesian Ridgeback',
    fr: 'Rhodesian Ridgeback',
    de: 'Rhodesian Ridgeback',
    it: 'Rhodesian Ridgeback'
  },

  mastin_espanol: {
    es: 'Mastín Español',
    en: 'Spanish Mastiff',
    fr: 'Mastiff Espagnol',
    de: 'Spanischer Mastiff',
    it: 'Mastino Spagnolo'
  },

  border_terrier: {
    es: 'Border Terrier',
    en: 'Border Terrier',
    fr: 'Border Terrier',
    de: 'Border Terrier',
    it: 'Border Terrier'
  },

  akita_inu: {
    es: 'Akita Inu',
    en: 'Akita Inu',
    fr: 'Akita Inu',
    de: 'Akita Inu',
    it: 'Akita Inu'
  },

  mastin_napolitano: {
    es: 'Mastín Napolitano',
    en: 'Neapolitan Mastiff',
    fr: 'Mastiff Napolitain',
    de: 'Mastino Napoletano',
    it: 'Mastino Napoletano'
  },

  husky_siberiano: {
    es: 'Husky Siberiano',
    en: 'Siberian Husky',
    fr: 'Husky Sibérien',
    de: 'Sibirischer Husky',
    it: 'Husky Siberiano'
  },

  san_bernardo: {
    es: 'San Bernardo',
    en: 'Saint Bernard',
    fr: 'Saint-Bernard',
    de: 'Bernhardiner',
    it: 'San Bernardo'
  },

  samoyedo: {
    es: 'Samoyedo',
    en: 'Samoyed',
    fr: 'Samoyède',
    de: 'Samojede',
    it: 'Samoiedo'
  },

  leonberger: {
    es: 'Leonberger',
    en: 'Leonberger',
    fr: 'Leonberg',
    de: 'Leonberger',
    it: 'Leonberger'
  },

  boyero_de_berna: {
    es: 'Boyero de Berna',
    en: 'Bernese Mountain Dog',
    fr: 'Bouvier Bernois',
    de: 'Berner Sennenhund',
    it: 'Bovaro del Bernese'
  },

  fox_terrier: {
    es: 'Fox Terrier',
    en: 'Fox Terrier',
    fr: 'Fox Terrier',
    de: 'Fox Terrier',
    it: 'Fox Terrier'
  },

  cairn_terrier: {
    es: 'Cairn Terrier',
    en: 'Cairn Terrier',
    fr: 'Cairn Terrier',
    de: 'Cairn Terrier',
    it: 'Cairn Terrier'
  },

  lhasa_apso: {
    es: 'Lhasa Apso',
    en: 'Lhasa Apso',
    fr: 'Lhassa Apso',
    de: 'Lhasa Apso',
    it: 'Lhasa Apso'
  },

  parson_russell_terrier: {
    es: 'Parson Russell Terrier',
    en: 'Parson Russell Terrier',
    fr: 'Parson Russell Terrier',
    de: 'Parson Russell Terrier',
    it: 'Parson Russell Terrier'
  },

    caniche_enano: {
    es: 'Caniche Enano',
    en: 'Miniature Poodle',
    fr: 'Caniche Nain',
    de: 'Zwergpudel',
    it: 'Barboncino Nano'
  },

  caniche: {
    es: 'Caniche',
    en: 'Poodle',
    fr: 'Caniche',
    de: 'Pudel',
    it: 'Barboncino'
  },

  caniche_grande: {
    es: 'Caniche Grande',
    en: 'Standard Poodle',
    fr: 'Caniche Standard',
    de: 'Großpudel',
    it: 'Barbone Grande'
  },

  cockapoo: {
    es: 'Cockapoo',
    en: 'Cockapoo',
    fr: 'Cockapoo',
    de: 'Cockapoo',
    it: 'Cockapoo'
  },

  goldendoodle: {
    es: 'Goldendoodle',
    en: 'Goldendoodle',
    fr: 'Goldendoodle',
    de: 'Goldendoodle',
    it: 'Goldendoodle'
  },

  labradoodle: {
    es: 'Labradoodle',
    en: 'Labradoodle',
    fr: 'Labradoodle',
    de: 'Labradoodle',
    it: 'Labradoodle'
  },

  american_bully: {
    es: 'American Bully',
    en: 'American Bully',
    fr: 'American Bully',
    de: 'American Bully',
    it: 'American Bully'
  },

  bull_terrier: {
    es: 'Bull Terrier',
    en: 'Bull Terrier',
    fr: 'Bull Terrier',
    de: 'Bull Terrier',
    it: 'Bull Terrier'
  },

  bodeguero_andaluz: {
    es: 'Bodeguero Andaluz',
    en: 'Andalusian Rat Terrier',
    fr: 'Bodeguero Andalou',
    de: 'Andalusischer Rattenfänger',
    it: 'Bodeguero Andaluso'
  },

  galgo_arabe: {
    es: 'Galgo Árabe',
    en: 'Sloughi',
    fr: 'Sloughi',
    de: 'Sloughi',
    it: 'Sloughi'
  },

  podenco_canario: {
    es: 'Podenco Canario',
    en: 'Canarian Hound',
    fr: 'Podenco Canarien',
    de: 'Kanarischer Podenco',
    it: 'Podenco Canario'
  },

  podenco_maneto: {
    es: 'Podenco Maneto',
    en: 'Maneto Hound',
    fr: 'Podenco Maneto',
    de: 'Podenco Maneto',
    it: 'Podenco Maneto'
  },

  jackapoo: {
    es: 'Jackapoo',
    en: 'Jackapoo',
    fr: 'Jackapoo',
    de: 'Jackapoo',
    it: 'Jackapoo'
  },

  cavachon: {
    es: 'Cavachon',
    en: 'Cavachon',
    fr: 'Cavachon',
    de: 'Cavachon',
    it: 'Cavachon'
  },

  biewer_terrier: {
    es: 'Biewer Terrier',
    en: 'Biewer Terrier',
    fr: 'Biewer Terrier',
    de: 'Biewer Terrier',
    it: 'Biewer Terrier'
  },

  mestizo_toy: {
    es: 'Mestizo Toy',
    en: 'Toy Mixed Breed',
    fr: 'Croisé Toy',
    de: 'Toy-Mischling',
    it: 'Meticcio Toy'
  },

  mestizo_pequeno: {
    es: 'Mestizo Pequeño',
    en: 'Small Mixed Breed',
    fr: 'Petit Chien Croisé',
    de: 'Kleiner Mischling',
    it: 'Meticcio Piccolo'
  },

  mestizo_mediano: {
    es: 'Mestizo Mediano',
    en: 'Medium Mixed Breed',
    fr: 'Chien Croisé Moyen',
    de: 'Mittelgroßer Mischling',
    it: 'Meticcio Medio'
  },

  mestizo_grande: {
    es: 'Mestizo Grande',
    en: 'Large Mixed Breed',
    fr: 'Grand Chien Croisé',
    de: 'Großer Mischling',
    it: 'Meticcio Grande'
  },

  mestizo_gigante: {
    es: 'Mestizo Gigante',
    en: 'Giant Mixed Breed',
    fr: 'Très Grand Chien Croisé',
    de: 'Riesen-Mischling',
    it: 'Meticcio Gigante'
  }

};

  const BREEDS = [
  { id: 'bichon_maltes', name: 'Bichón Maltés', aliases: 'maltes,maltese,maltés', group: 'Toy', popularity: 100 },
  { id: 'caniche_toy', name: 'Caniche Toy', aliases: 'toy poodle,poodle toy', group: 'Toy', popularity: 99 },
  { id: 'pomerania', name: 'Pomerania', aliases: '', group: 'Toy', popularity: 98 },
  { id: 'chihuahua', name: 'Chihuahua', aliases: '', group: 'Toy', popularity: 97 },
  { id: 'yorkshire_terrier', name: 'Yorkshire Terrier', aliases: 'yorkie', group: 'Toy', popularity: 96 },
  { id: 'shih_tzu', name: 'Shih Tzu', aliases: '', group: 'Toy', popularity: 95 },
  { id: 'teckel_miniatura', name: 'Teckel Miniatura', aliases: '', group: 'Small', popularity: 94 },
  { id: 'teckel', name: 'Teckel', aliases: 'dachshund,salchicha', group: 'Small', popularity: 93 },
  { id: 'bulldog_frances', name: 'Bulldog Francés', aliases: 'frenchie,french bulldog', group: 'Medium', popularity: 92 },
  { id: 'whippet', name: 'Whippet', aliases: '', group: 'Sighthound', popularity: 91 },
  { id: 'jack_russell_terrier', name: 'Jack Russell Terrier', aliases: '', group: 'Small', popularity: 90 },
  { id: 'mestizo_toy', name: 'Mestizo Toy', aliases: '', group: 'Mixed', popularity: 90 },
  { id: 'cavalier_king_charles_spaniel', name: 'Cavalier King Charles Spaniel', aliases: 'cavalier', group: 'Small', popularity: 89 },
  { id: 'mestizo_pequeno', name: 'Mestizo Pequeño', aliases: '', group: 'Mixed', popularity: 89 },
  { id: 'beagle', name: 'Beagle', aliases: '', group: 'Medium', popularity: 88 },
  { id: 'mestizo_mediano', name: 'Mestizo Mediano', aliases: '', group: 'Mixed', popularity: 88 },
  { id: 'mestizo_grande', name: 'Mestizo Grande', aliases: '', group: 'Mixed', popularity: 87 },
  { id: 'galgo_italiano', name: 'Galgo Italiano', aliases: '', group: 'Sighthound', popularity: 87 },
  { id: 'mestizo_gigante', name: 'Mestizo Gigante', aliases: '', group: 'Mixed', popularity: 86 },
  { id: 'galgo_espanol', name: 'Galgo Español', aliases: 'galgo', group: 'Sighthound', popularity: 86 },
  { id: 'cocker_spaniel_ingles', name: 'Cocker Spaniel Inglés', aliases: '', group: 'Medium', popularity: 86 },
  { id: 'west_highland_white_terrier', name: 'West Highland White Terrier', aliases: 'westie', group: 'Small', popularity: 85 },
  { id: 'boston_terrier', name: 'Boston Terrier', aliases: '', group: 'Small', popularity: 84 },
  { id: 'border_collie', name: 'Border Collie', aliases: '', group: 'Medium', popularity: 83 },
  { id: 'schnauzer_miniatura', name: 'Schnauzer Miniatura', aliases: '', group: 'Small', popularity: 82 },
  { id: 'australian_shepherd', name: 'Australian Shepherd', aliases: '', group: 'Medium', popularity: 81 },
  { id: 'bichon_frise', name: 'Bichón Frisé', aliases: '', group: 'Toy', popularity: 80 },
  { id: 'labrador_retriever', name: 'Labrador Retriever', aliases: 'labrador', group: 'Large', popularity: 80 },
  { id: 'shiba_inu', name: 'Shiba Inu', aliases: '', group: 'Medium', popularity: 79 },
  { id: 'golden_retriever', name: 'Golden Retriever', aliases: 'golden', group: 'Large', popularity: 79 },
  { id: 'pastor_aleman', name: 'Pastor Alemán', aliases: '', group: 'Large', popularity: 78 },
  { id: 'bichon_habanero', name: 'Bichón Habanero', aliases: '', group: 'Toy', popularity: 78 },
  { id: 'bulldog_ingles', name: 'Bulldog Inglés', aliases: '', group: 'Medium', popularity: 77 },
  { id: 'maltipoo', name: 'Maltipoo', aliases: '', group: 'Toy', popularity: 76 },
  { id: 'boxer', name: 'Boxer', aliases: '', group: 'Large', popularity: 76 },
  { id: 'staffordshire_bull_terrier', name: 'Staffordshire Bull Terrier', aliases: '', group: 'Medium', popularity: 75 },
  { id: 'greyhound', name: 'Greyhound', aliases: 'galgo ingles', group: 'Sighthound', popularity: 74 },
  { id: 'cavapoo', name: 'Cavapoo', aliases: '', group: 'Toy', popularity: 74 },
  { id: 'dalmata', name: 'Dálmata', aliases: '', group: 'Large', popularity: 74 },
  { id: 'cocker_spaniel_americano', name: 'Cocker Spaniel Americano', aliases: '', group: 'Medium', popularity: 73 },
  { id: 'poochon', name: 'Poochon', aliases: '', group: 'Toy', popularity: 72 },
  { id: 'podenco_ibicenco', name: 'Podenco Ibicenco', aliases: '', group: 'Sighthound', popularity: 72 },
  { id: 'dobermann', name: 'Dobermann', aliases: '', group: 'Large', popularity: 72 },
  { id: 'springer_spaniel_ingles', name: 'Springer Spaniel Inglés', aliases: '', group: 'Medium', popularity: 71 },
  { id: 'pekines', name: 'Pekingés', aliases: '', group: 'Toy', popularity: 70 },
  { id: 'podenco_andaluz', name: 'Podenco Andaluz', aliases: '', group: 'Sighthound', popularity: 70 },
  { id: 'rottweiler', name: 'Rottweiler', aliases: '', group: 'Large', popularity: 70 },
  { id: 'basenji', name: 'Basenji', aliases: '', group: 'Medium', popularity: 69 },
  { id: 'papillon', name: 'Papillón', aliases: '', group: 'Toy', popularity: 68 },
  { id: 'saluki', name: 'Saluki', aliases: '', group: 'Sighthound', popularity: 68 },
  { id: 'weimaraner', name: 'Weimaraner', aliases: '', group: 'Large', popularity: 68 },
  { id: 'breton', name: 'Bretón', aliases: '', group: 'Medium', popularity: 67 },
  { id: 'pinscher_miniatura', name: 'Pinscher Miniatura', aliases: '', group: 'Toy', popularity: 66 },
  { id: 'borzoi', name: 'Borzoi', aliases: '', group: 'Sighthound', popularity: 66 },
  { id: 'pastor_belga_malinois', name: 'Pastor Belga Malinois', aliases: '', group: 'Large', popularity: 66 },
  { id: 'podenco_mediano', name: 'Podenco Mediano', aliases: '', group: 'Medium', popularity: 65 },
  { id: 'russian_toy', name: 'Russian Toy', aliases: '', group: 'Toy', popularity: 64 },
  { id: 'setter_ingles', name: 'Setter Inglés', aliases: '', group: 'Large', popularity: 64 },
  { id: 'coton_de_tulear', name: 'Coton de Tuléar', aliases: '', group: 'Toy', popularity: 62 },
  { id: 'norfolk_terrier', name: 'Norfolk Terrier', aliases: '', group: 'Small', popularity: 62 },
  { id: 'setter_irlandes', name: 'Setter Irlandés', aliases: '', group: 'Large', popularity: 62 },
  { id: 'norwich_terrier', name: 'Norwich Terrier', aliases: '', group: 'Small', popularity: 60 },
  { id: 'vizsla', name: 'Vizsla', aliases: '', group: 'Large', popularity: 60 },
  { id: 'gran_danes', name: 'Gran Danés', aliases: '', group: 'Giant', popularity: 60 },
  { id: 'scottish_terrier', name: 'Scottish Terrier', aliases: '', group: 'Small', popularity: 58 },
  { id: 'braco_aleman', name: 'Braco Alemán', aliases: '', group: 'Large', popularity: 58 },
  { id: 'terranova', name: 'Terranova', aliases: '', group: 'Giant', popularity: 58 },
  { id: 'welsh_terrier', name: 'Welsh Terrier', aliases: '', group: 'Small', popularity: 56 },
  { id: 'rhodesian_ridgeback', name: 'Rhodesian Ridgeback', aliases: '', group: 'Large', popularity: 56 },
  { id: 'mastin_espanol', name: 'Mastín Español', aliases: '', group: 'Giant', popularity: 56 },
  { id: 'border_terrier', name: 'Border Terrier', aliases: '', group: 'Small', popularity: 54 },
  { id: 'akita_inu', name: 'Akita Inu', aliases: '', group: 'Large', popularity: 54 },
  { id: 'mastin_napolitano', name: 'Mastín Napolitano', aliases: '', group: 'Giant', popularity: 54 },
  { id: 'husky_siberiano', name: 'Husky Siberiano', aliases: '', group: 'Large', popularity: 52 },
  { id: 'san_bernardo', name: 'San Bernardo', aliases: '', group: 'Giant', popularity: 52 },
  { id: 'samoyedo', name: 'Samoyedo', aliases: '', group: 'Large', popularity: 50 },
  { id: 'leonberger', name: 'Leonberger', aliases: '', group: 'Giant', popularity: 50 },
  { id: 'boyero_de_berna', name: 'Boyero de Berna', aliases: '', group: 'Giant', popularity: 48 },
  { id: 'fox_terrier', name: 'Fox Terrier', aliases: '', group: 'Small', popularity: 66 },
  { id: 'cairn_terrier', name: 'Cairn Terrier', aliases: '', group: 'Small', popularity: 64 },
  { id: 'lhasa_apso', name: 'Lhasa Apso', aliases: '', group: 'Small', popularity: 68 },
  { id: 'parson_russell_terrier', name: 'Parson Russell Terrier', aliases: '', group: 'Small', popularity: 70 },
  { id: 'caniche_enano', name: 'Caniche Enano', aliases: 'miniature poodle,mini poodle', group: 'Small', popularity: 84 },
  { id: 'caniche', name: 'Caniche', aliases: 'poodle', group: 'Medium', popularity: 83 },
  { id: 'caniche_grande', name: 'Caniche Grande', aliases: 'standard poodle', group: 'Large', popularity: 72 },
  { id: 'cockapoo', name: 'Cockapoo', aliases: '', group: 'Medium', popularity: 80 },
  { id: 'goldendoodle', name: 'Goldendoodle', aliases: '', group: 'Large', popularity: 74 },
  { id: 'labradoodle', name: 'Labradoodle', aliases: '', group: 'Large', popularity: 73 },
  { id: 'american_bully', name: 'American Bully', aliases: '', group: 'Medium', popularity: 74 },
  { id: 'bull_terrier', name: 'Bull Terrier', aliases: '', group: 'Medium', popularity: 68 },
  { id: 'bodeguero_andaluz', name: 'Bodeguero Andaluz', aliases: 'ratonero bodeguero andaluz', group: 'Small', popularity: 76 },
  { id: 'galgo_arabe', name: 'Galgo Árabe', aliases: 'sloughi', group: 'Sighthound', popularity: 60 },
  { id: 'podenco_canario', name: 'Podenco Canario', aliases: '', group: 'Sighthound', popularity: 65 },
  { id: 'podenco_maneto', name: 'Podenco Maneto', aliases: '', group: 'Small', popularity: 55 },
  { id: 'jackapoo', name: 'Jackapoo', aliases: '', group: 'Small', popularity: 60 },
  { id: 'cavachon', name: 'Cavachon', aliases: '', group: 'Toy', popularity: 60 },
  { id: 'biewer_terrier', name: 'Biewer Terrier', aliases: '', group: 'Toy', popularity: 55 },
  { id: 'otra_raza', name: 'Otra raza', aliases: '', group: 'Other', popularity: 1 }
  
];

const BREED_MEASURE_IMAGES = {
  'step-in-harness': {
    teckel: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-teckel.jpg?v=1781603422',
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-teckel.jpg?v=1781603422',
    chihuahua: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-chihuahua.jpg?v=1781603423',
    yorkshire_terrier: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-yorkshire.jpg?v=1781603422',
    caniche_toy: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-caniche.jpg?v=1781603422',
    bulldog_frances: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-bulldog-frances.jpg?v=1781603423',
    galgo_italiano: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-step-in-galgo-italiano.jpg?v=1781603422'
  },

  'h-harness': {
    teckel: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-teckel.jpg?v=1781603422',
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-teckel.jpg?v=1781603422',
    chihuahua: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-chihuahua.jpg?v=1781603422',
    yorkshire_terrier: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-yorkshire.jpg?v=1781603422',
    caniche_toy: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-chihuahua.jpg?v=1781603422',
    bulldog_frances: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-bulldog-frances.jpg?v=1781603422',
    galgo_italiano: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-galgo-italiano.jpg?v=1781603423',
    whippet: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-whippet.jpg?v=1781603422',
    galgo_espanol: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-arnes-h-galgo-espanol.jpg?v=1781603422'
  },
  
  'standard-collar': {
    teckel: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    chihuahua: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-chihuahua.jpg?v=1781603423',
    yorkshire_terrier: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-yorkshire.jpg?v=1781603422',
    caniche_toy: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-caniche.jpg?v=1781603422',
    bulldog_frances: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-bulldog-frances.jpg?v=1781603423',
    galgo_italiano: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-italiano.jpg?v=1781603423',
    whippet: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-whippet.jpg?v=1781603422',
    galgo_espanol: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-espanol.jpg?v=1781603422'  
  },

  'classic-collar': {
    teckel: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    chihuahua: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-chihuahua.jpg?v=1781603423',
    yorkshire_terrier: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-yorkshire.jpg?v=1781603422',
    caniche_toy: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-caniche.jpg?v=1781603422',
    bulldog_frances: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-bulldog-frances.jpg?v=1781603423',
    galgo_italiano: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-italiano.jpg?v=1781603423',
    whippet: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-whippet.jpg?v=1781603422',
    galgo_espanol: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-espanol.jpg?v=1781603422' 
  },

  'toy-collar': {
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    chihuahua: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-chihuahua.jpg?v=1781603423',
    yorkshire_terrier: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-yorkshire.jpg?v=1781603422',
    caniche_toy: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-caniche.jpg?v=1781603422'
  },

  'greyhound-collar': {
    teckel: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    teckel_miniatura: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-teckel.jpg?v=1781603423',
    galgo_italiano: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-italiano.jpg?v=1781603423',
    whippet: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-whippet.jpg?v=1781603422',
    galgo_espanol: 'https://cdn.shopify.com/s/files/1/0270/9038/7031/files/guia-tallas-collar-galgo-espanol.jpg?v=1781603422'
  }
};

  const COLLECTION_URLS = {
    toyCollars: 'https://brannipets.com/collections/collares-perros-toy',
    standardCollars: 'https://brannipets.com/collections/collares-estandar',
    stepInHarnesses: 'https://brannipets.com/collections/arneses-juno',
    hHarnesses: 'https://brannipets.com/collections/arneses-en-h'
};


const BREED_SIZE_RECOMMENDATIONS = {
  chihuahua: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'S',
    'step-in-harness': 'S',
    'h-harness': 'XS'
  },

  bichon_maltes: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'S',
    'step-in-harness': 'S',
    'h-harness': 'XS'
  },

  caniche_toy: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'XS',
    'step-in-harness': 'XS',
    'h-harness': 'XS'
  },

  teckel_miniatura: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'S',
    'greyhound-collar': 'XS',
    'step-in-harness': 'S',
    'h-harness': 'XS'
  },

  teckel: {
    'greyhound-collar': 'S',
    'step-in-harness': 'M',
    'h-harness': 'S/M'
  },

  bulldog_frances: {
    'standard-collar': 'M',
    'classic-collar': 'M',
    'step-in-harness': 'M',
    'h-harness': 'M'
  },

  pomerania: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'XS',
    'step-in-harness': 'S',
    'h-harness': 'XS'
  },

  yorkshire_terrier: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'step-in-harness': 'XS',
    'h-harness': 'XS'
  },

  galgo_italiano: {
    'greyhound-collar': 'S',
    'h-harness': 'S'
  },

  maltipoo: {
    'toy-collar': 'XS',
    'step-in-harness': 'XS'
  },

  cavapoo: {
    'toy-collar': 'XS',
    'step-in-harness': 'XS'
  },

  caniche: {
    'standard-collar': 'S',
    'classic-collar': 'S',
    'step-in-harness': 'M',
    'h-harness': 'S/M'
  },

  caniche_enano: {
    'toy-collar': 'XS',
    'step-in-harness': 'XS',
    'h-harness': 'XS'
  },

  galgo_espanol: {
    'greyhound-collar': 'L'
  },

  pinscher_miniatura: {
    'standard-collar': 'XS',
    'classic-collar': 'XS',
    'toy-collar': 'S',
    'h-harness': 'XS'
  },

  schnauzer_miniatura: {
    'standard-collar': 'S',
    'classic-collar': 'S',
    'toy-collar': 'M',
    'step-in-harness': 'S',
    'h-harness': 'S/M'
  },

  whippet: {
    'greyhound-collar': 'M'
  },

  greyhound: {
    'standard-collar': 'M',
    'classic-collar': 'M',
    'greyhound-collar': 'M'
  },

  jack_russell_terrier: {
    'standard-collar': 'S',
    'classic-collar': 'S',
    'step-in-harness': 'S',
    'h-harness': 'S'
  }
};

  const CALCULATOR_MEASURES = {
    'standard-collar': ['neck'],
    'classic-collar': ['neck'],
    'toy-collar': ['neck'],
    'greyhound-collar': ['neck'],
    'step-in-harness': ['chest', 'girth'],
    'h-harness': ['neck', 'girth']
  };

  const SIZE_RULES = {
    'standard-collar': [
      { size: 'XS', measure1: 'neck', min1: 21.5, max1: 27.5, order: 1 },
      { size: 'S', measure1: 'neck', min1: 26.5, max1: 32, order: 2 },
      { size: 'M', measure1: 'neck', min1: 31.5, max1: 37, order: 3 },
      { size: 'L', measure1: 'neck', min1: 37.5, max1: 43.5, order: 4 },
      { size: 'L2', measure1: 'neck', min1: 42.5, max1: 48.5, order: 5 },
      { size: 'XL', measure1: 'neck', min1: 47.5, max1: 53.5, order: 6 }
    ],
    'classic-collar': [
      { size: 'XS', measure1: 'neck', min1: 21.5, max1: 27.5, order: 1 },
      { size: 'S', measure1: 'neck', min1: 26.5, max1: 32, order: 2 },
      { size: 'M', measure1: 'neck', min1: 31.5, max1: 37, order: 3 },
      { size: 'L', measure1: 'neck', min1: 37.5, max1: 43.5, order: 4 },
      { size: 'L2', measure1: 'neck', min1: 42.5, max1: 48.5, order: 5 },
      { size: 'XL', measure1: 'neck', min1: 47.5, max1: 53.5, order: 6 }
    ],
    'toy-collar': [
      { size: 'XS', measure1: 'neck', min1: 16, max1: 21, order: 1 },
      { size: 'S', measure1: 'neck', min1: 21.5, max1: 26.5, order: 2 },
      { size: 'M', measure1: 'neck', min1: 27, max1: 32, order: 3 }
    ],
    'greyhound-collar': [
      { size: 'XS', measure1: 'neck', min1: 21.5, max1: 25.5, order: 1 },
      { size: 'S', measure1: 'neck', min1: 24.5, max1: 28.5, order: 2 },
      { size: 'M', measure1: 'neck', min1: 28.5, max1: 32.5, order: 3 },
      { size: 'L', measure1: 'neck', min1: 31.5, max1: 36, order: 4 },
      { size: 'XL', measure1: 'neck', min1: 36.5, max1: 40.5, order: 5 }
    ],
    'step-in-harness': [
      { size: 'XS', measure1: 'chest', min1: 26, max1: 33, measure2: 'girth', min2: 30, max2: 35, order: 1 },
      { size: 'S', measure1: 'chest', min1: 34, max1: 40, measure2: 'girth', min2: 37, max2: 43, order: 2 },
      { size: 'M', measure1: 'chest', min1: 41, max1: 52, measure2: 'girth', min2: 44, max2: 55, order: 3 }
    ],
    'h-harness': [
      { size: 'XS', measure1: 'neck', min1: 24, max1: 30, measure2: 'girth', min2: 37, max2: 43, order: 1 },
      { size: 'S', measure1: 'neck', min1: 27, max1: 33, measure2: 'girth', min2: 42, max2: 48, order: 2 },
      { size: 'S/M', measure1: 'neck', min1: 30, max1: 36, measure2: 'girth', min2: 45, max2: 51, order: 3 },
      { size: 'M', measure1: 'neck', min1: 33, max1: 39, measure2: 'girth', min2: 50, max2: 56, order: 4 },
      { size: 'L', measure1: 'neck', min1: 36, max1: 42, measure2: 'girth', min2: 55, max2: 61, order: 5 }
    ]
  };

  function normaliseText(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function getCurrentLanguage() {
  return Shopify.locale || 'es';
}

function getBreedName(breed) {
  const lang = getCurrentLanguage();
  return BREED_NAMES[breed.id]?.[lang] || breed.name;
}

  function isCollarWithUpperPreference(type) {
  return ['standard-collar', 'classic-collar', 'greyhound-collar'].includes(type);
}

  function updateMeasureImage(calculator, calculatorType, breedId) {
    const image = calculator.querySelector('.branni-measure-image');
    if (!image) return;

    const defaultSrc = image.getAttribute('data-default-src') || image.getAttribute('src');
    const imageMap = BREED_MEASURE_IMAGES[calculatorType] || {};
    const newSrc = imageMap[breedId] || defaultSrc;

    image.setAttribute('src', newSrc);
  }

  function updateBreedSizeHint(calculator, calculatorType, breedId, breedName) {
  let hint = calculator.querySelector('.branni-breed-size-hint');

  if (!hint) {
    hint = document.createElement('div');
    hint.className = 'branni-breed-size-hint';

    const breedField = calculator.querySelector('#branni-breed')?.closest('.branni-field');

    if (breedField) {
      breedField.insertAdjacentElement('afterend', hint);
    }
  }

  const suggestedSize = BREED_SIZE_RECOMMENDATIONS[breedId]?.[calculatorType];

  if (!suggestedSize) {
    hint.style.display = 'none';
    hint.innerHTML = '';
    return;
  }

  hint.style.display = 'block';
  const breedSizeTitle = calculator.dataset.breedSizeTitle || '';
  const breedSizeTextBefore = calculator.dataset.breedSizeTextBefore || '';
  const breedSizeTextAfter = calculator.dataset.breedSizeTextAfter || '';
  const breedSizeDisclaimer = calculator.dataset.breedSizeDisclaimer || '';

  hint.innerHTML =
    '<strong>' + breedSizeTitle + ' ' + suggestedSize + '</strong><br>' +
    '<span>' + breedSizeTextBefore + ' ' + breedName + '. ' + breedSizeTextAfter + '</span>' +
    (breedSizeDisclaimer
      ? '<small>* ' + breedSizeDisclaimer + '</small>'
      : '');
    }

  function initBreedSearch(calculator) {
    const input = calculator.querySelector('#branni-breed');
    const hiddenInput = calculator.querySelector('#branni-breed-id');
    const results = calculator.querySelector('#branni-breed-results');

    if (!input || !hiddenInput || !results) return;

    input.addEventListener('input', function () {
      const query = normaliseText(input.value);
      hiddenInput.value = '';
      updateBreedSizeHint(calculator, calculator.getAttribute('data-calculator-type'), '', '');

      if (query.length < 2) {
        results.style.display = 'none';
        results.innerHTML = '';
        return;
      }

      const matches = BREEDS
        .filter(function (breed) {
          return (
            normaliseText(breed.name).includes(query) ||
            normaliseText(breed.id).includes(query) ||
            normaliseText(breed.aliases).includes(query)
          );
        })
        .sort(function (a, b) { return b.popularity - a.popularity; })
        .slice(0, 6);

      const finalMatches = matches.length ? matches : [BREEDS.find(function (b) { return b.id === 'otra_raza'; })];

      results.innerHTML = finalMatches.map(function (breed) {
        return '<div class="branni-breed-option" data-breed-id="' + breed.id + '">' + getBreedName(breed) + '</div>';
      }).join('');

      results.style.display = 'block';
    });

    results.addEventListener('click', function (event) {
      const option = event.target.closest('.branni-breed-option');
      if (!option) return;

      const breedId = option.getAttribute('data-breed-id');
      const breed = BREEDS.find(function (item) { return item.id === breedId; });

      if (!breed) return;

      input.value = getBreedName(breed);
      hiddenInput.value = breed.id;
      results.style.display = 'none';

      const calculatorType = calculator.getAttribute('data-calculator-type');
      updateMeasureImage(calculator, calculatorType, breed.id);
      updateBreedSizeHint(calculator, calculatorType, breed.id, getBreedName(breed));
    });
  }

  function setupVisibleMeasures(calculator, calculatorType) {
    const requiredMeasures = CALCULATOR_MEASURES[calculatorType] || [];

    calculator.querySelectorAll('.branni-measure-field').forEach(function (field) {
      const measure = field.getAttribute('data-measure');
      field.style.display = requiredMeasures.includes(measure) ? 'block' : 'none';
    });
  }

  function getMeasurements(calculator) {
    return {
      neck: Number(calculator.querySelector('#branni-neck')?.value || 0),
      chest: Number(calculator.querySelector('#branni-chest')?.value || 0),
      girth: Number(calculator.querySelector('#branni-girth')?.value || 0)
    };
  }

  function getMissingMeasures(calculatorType, measurements) {
    return (CALCULATOR_MEASURES[calculatorType] || []).filter(function (measure) {
      return !measurements[measure];
    });
  }

  function getMatchingSizes(calculatorType, measurements) {
    const rules = SIZE_RULES[calculatorType] || [];

    return rules.filter(function (rule) {
      const value1 = measurements[rule.measure1];
      const value2 = rule.measure2 ? measurements[rule.measure2] : null;

      if (!value1) return false;

      const match1 = value1 >= rule.min1 && value1 <= rule.max1;

      if (!rule.measure2) return match1;

      return match1 && value2 >= rule.min2 && value2 <= rule.max2;
    });
  }

  function getNextSize(rules, currentRule) {
    return rules.find(function (rule) {
      return rule.order === currentRule.order + 1;
    });
  }

  function calculateRecommendedSize(calculatorType, measurements) {
    const rules = SIZE_RULES[calculatorType] || [];
    const matches = getMatchingSizes(calculatorType, measurements);

    if (matches.length) {
      const sortedMatches = matches.sort(function (a, b) { return b.order - a.order; });
      const recommended = sortedMatches[0];

      if (isCollarWithUpperPreference(calculatorType) && sortedMatches.length === 1) {
        const value = measurements[recommended.measure1];
        const nextSize = getNextSize(rules, recommended);

        if (nextSize && value >= recommended.max1 - 1) {
          return nextSize;
        }
      }

      if (calculatorType === 'step-in-harness' && sortedMatches.length === 1) {
        const nextSize = getNextSize(rules, recommended);

        if (nextSize && (measurements.chest >= recommended.max1 || measurements.girth >= recommended.max2)) {
          return nextSize;
        }
      }

      if (calculatorType === 'h-harness' && sortedMatches.length > 1) {
        const highest = sortedMatches[0];

        if (highest.size === 'S/M' && measurements.neck === 30 && measurements.girth === 45) {
          return sortedMatches[1];
        }

        return highest;
      }

      return recommended;
    }

    const firstRule = rules
  .slice()
  .sort(function (a, b) { return a.order - b.order; })[0];

if (firstRule) {
  const value1 = measurements[firstRule.measure1];
  const value2 = firstRule.measure2 ? measurements[firstRule.measure2] : null;

  if (value1 < firstRule.min1) return null;
  if (firstRule.measure2 && value2 < firstRule.min2) return null;
}

return rules
  .filter(function (rule) {
    const value1 = measurements[rule.measure1];
    const value2 = rule.measure2 ? measurements[rule.measure2] : null;

    if (!value1) return false;
    if (value1 > rule.max1) return false;
    if (rule.measure2 && value2 > rule.max2) return false;

    return true;
  })
  .sort(function (a, b) {
    return a.order - b.order;
  })[0] || null;
  }

  function getMeasureLabel(calculator, measure) {
  const labels = {
    neck: calculator.dataset.neckLabel || '',
    chest: calculator.dataset.chestLabel || '',
    girth: calculator.dataset.girthLabel || ''
  };

  return labels[measure] || measure;
}

function injectCalculatorPropertiesIntoProductForm() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  const savedCalculator = localStorage.getItem('branni_size_calculator');

  if (!forms.length || !savedCalculator) return;

  let calculatorData;

  try {
    calculatorData = JSON.parse(savedCalculator);
  } catch (error) {
    return;
  }

  if (!calculatorData || !calculatorData.recommended_size) return;

  const properties = {
    '_Branni calculator version': calculatorData.calculator_version,
    '_Branni calculator type': calculatorData.calculator_type,
    '_Recommended size': calculatorData.recommended_size,
    '_Breed ID': calculatorData.breed_id || '',
    '_Weight': calculatorData.weight || '',
    '_Neck': calculatorData.neck || '',
    '_Chest': calculatorData.chest || '',
    '_Girth': calculatorData.girth || '',
    '_Unit used': calculatorData.unit_used || 'cm',
    '_Calculator timestamp': calculatorData.timestamp || ''
  };

  forms.forEach(function (form) {
    Object.keys(properties).forEach(function (key) {
      let input = form.querySelector('input[name="properties[' + key + ']"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        form.appendChild(input);
      }

      input.value = properties[key];
    });
  });
}

function getSmartFallback(calculator, calculatorType, measurements) {
  const neck = measurements.neck;
  const chest = measurements.chest;
  const girth = measurements.girth;

  if ((calculatorType === 'standard-collar' || calculatorType === 'classic-collar') && neck) {
    const toyMatch = calculateRecommendedSize('toy-collar', { neck: neck });

    if (toyMatch) {
      return {
        message: calculator.dataset.toyFallbackMessage || '',
        buttonText: calculator.dataset.toyFallbackButton || '',
        url: COLLECTION_URLS.toyCollars
      };
    }
  }

  if (calculatorType === 'toy-collar' && neck) {
    const standardMatch = calculateRecommendedSize('standard-collar', { neck: neck });

    if (standardMatch) {
      return {
        message: calculator.dataset.standardFallbackMessage || '',
        buttonText: calculator.dataset.standardFallbackButton || '',
        url: COLLECTION_URLS.standardCollars
      };
    }
  }

  if (calculatorType === 'step-in-harness' && chest && girth) {

  const isClearlyTooSmall =
    chest < 24 ||
    girth < 28;

  if (isClearlyTooSmall) {
    return {
      message: calculator.dataset.toyFallbackMessage || '',
      buttonText: calculator.dataset.toyFallbackButton || '',
      url: COLLECTION_URLS.toyCollars
    };
  }

}

  return null;
}

  function initCalculator(calculator) {
    const calculatorType = calculator.getAttribute('data-calculator-type');
    const button = calculator.querySelector('#branni-calculate-size');
    const result = calculator.querySelector('#branni-size-result');
    const texts = {
      otherBreed: calculator.dataset.otherBreed,
      missingPrefix: calculator.dataset.missingPrefix,
      missingSuffix: calculator.dataset.missingSuffix,
      noSizeTitle: calculator.dataset.noSizeTitle,
      noSizeMessage: calculator.dataset.noSizeMessage,
      sizePrefix: calculator.dataset.sizePrefix,
      sizeMessage: calculator.dataset.sizeMessage
    };

    if (!calculatorType || !button || !result) return;

    setupVisibleMeasures(calculator, calculatorType);
    initBreedSearch(calculator);

    button.addEventListener('click', function () {
      const breedId = calculator.querySelector('#branni-breed-id')?.value || '';
      const weight = Number(calculator.querySelector('#branni-weight')?.value || 0);
      const measurements = getMeasurements(calculator);
      const missingMeasures = getMissingMeasures(calculatorType, measurements);

      result.style.display = 'block';

      if (missingMeasures.length) {
        result.innerHTML =
          texts.missingPrefix + ' ' +
          missingMeasures.map(function (measure) {
         return getMeasureLabel(calculator, measure);
         }).join(' ' + (calculator.dataset.andLabel || '') + ' ') +
          ' ' + texts.missingSuffix;
        return;
      }

      const recommended = calculateRecommendedSize(calculatorType, measurements);

      if (!recommended) {
        const smartFallback = getSmartFallback(calculator, calculatorType, measurements);

        if (smartFallback && smartFallback.message && smartFallback.buttonText) {
          result.innerHTML =
          smartFallback.message +
          '<br><br><a class="branni-size-result-link" href="' + smartFallback.url + '">' +
          smartFallback.buttonText +
          '</a>';
        return;
  }

  result.innerHTML =
  '<strong>' + texts.noSizeTitle + '</strong><br>' +
  texts.noSizeMessage +
  '<br><br>' +
  (calculator.dataset.contactBefore || '') +
  ' <a href="mailto:orders@brannipets.com">orders@brannipets.com</a> ' +
  (calculator.dataset.contactAfter || '');
  return;
}

      const eventData = {
        calculator_version: CALCULATOR_VERSION,
        calculator_type: calculatorType,
        breed_id: breedId,
        weight: weight || null,
        neck: measurements.neck || null,
        chest: measurements.chest || null,
        girth: measurements.girth || null,
        recommended_size: recommended.size,
        unit_used: 'cm',
        timestamp: new Date().toISOString()
      };

      localStorage.setItem('branni_size_calculator', JSON.stringify(eventData));
      injectCalculatorPropertiesIntoProductForm();

      result.innerHTML =
        '<strong>' + texts.sizePrefix + ' ' + recommended.size + '</strong><br>' +
        texts.sizeMessage;
    });
  }

  function initAllBranniCalculators() {
  document.querySelectorAll('.branni-size-calculator').forEach(function (calculator) {
    if (calculator.dataset.branniInitialized === 'true') return;

    initCalculator(calculator);
    calculator.dataset.branniInitialized = 'true';
  });
}

document.addEventListener('DOMContentLoaded', initAllBranniCalculators);

const branniObserver = new MutationObserver(function () {
  initAllBranniCalculators();
  injectCalculatorPropertiesIntoProductForm();
});

branniObserver.observe(document.body, {
  childList: true,
  subtree: true
});

  document.addEventListener('submit', function (event) {
  const form = event.target.closest('form[action="/cart/add"]');
  if (!form) return;

  const savedCalculator = localStorage.getItem('branni_size_calculator');
  if (!savedCalculator) return;

  let calculatorData;

  try {
    calculatorData = JSON.parse(savedCalculator);
  } catch (error) {
    return;
  }

  if (!calculatorData || !calculatorData.recommended_size) return;

  const properties = {
    '_Branni calculator version': calculatorData.calculator_version,
    '_Branni calculator type': calculatorData.calculator_type,
    '_Recommended size': calculatorData.recommended_size,
    '_Breed ID': calculatorData.breed_id || '',
    '_Weight': calculatorData.weight || '',
    '_Neck': calculatorData.neck || '',
    '_Chest': calculatorData.chest || '',
    '_Girth': calculatorData.girth || '',
    '_Unit used': calculatorData.unit_used || 'cm',
    '_Calculator timestamp': calculatorData.timestamp || ''
  };

  Object.keys(properties).forEach(function (key) {
    let input = form.querySelector('input[name="properties[' + key + ']"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      form.appendChild(input);
    }

    input.value = properties[key];
  });
}, true);

})();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
